import { memo, useState } from "react";
import { MessageCircle } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export const WhatsAppFloating = memo(() => {
  const [isHovered, setIsHovered] = useState(false);
  const whatsappUrl = `https://api.whatsapp.com/send?phone=5583986147064&text=${encodeURIComponent("Olá! Vim do site p2propaineliptv.com.br, gostaria de mais informações.")}`;

  return (
    <div 
      className="fixed bottom-8 right-8 z-[999] flex flex-col items-end gap-3"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onTouchStart={() => setIsHovered(true)}
    >
      <AnimatePresence>
        {isHovered && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.9 }}
            className="bg-white text-black text-[11px] font-black uppercase tracking-[0.2em] px-4 py-2.5 rounded-xl shadow-2xl border border-black/5 whitespace-nowrap mb-1"
          >
            Atendimento Online Agora
          </motion.div>
        )}
      </AnimatePresence>

      <motion.a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0 }}
        animate={{ 
          scale: 1,
          y: [0, -10, 0], // Jumping effect
        }}
        transition={{
          scale: { type: "spring", stiffness: 260, damping: 20 },
          y: {
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }
        }}
        whileHover={{ scale: 1.1, y: 0 }}
        whileTap={{ scale: 0.9 }}
        className="relative bg-[#25D366] text-white p-5 rounded-full shadow-[0_15px_40px_rgba(37,211,102,0.5)] flex items-center justify-center group cursor-pointer min-w-[60px] min-h-[60px]"
        aria-label="Fale conosco pelo WhatsApp"
      >
        {/* Active Indicator Dot */}
        <div className="absolute -top-1 -right-1 w-4 h-4 bg-[#4ade80] rounded-full border-2 border-[#0a0c10] z-20 shadow-sm">
          <div className="absolute inset-0 bg-[#4ade80] rounded-full animate-ping opacity-75" />
        </div>

        <div className="absolute -inset-1 bg-[#25D366] rounded-full blur-md opacity-20 group-hover:opacity-40 transition-opacity" />
        
        <MessageCircle className="w-8 h-8 relative z-10" fill="currentColor" />
      </motion.a>
    </div>
  );
});

WhatsAppFloating.displayName = "WhatsAppFloating";
